export const AMPLITUDE_KEY = 'cd80b9d1ba0f68979987279bdaaa80f4';
